import { PartFinderReport } from '@/api/generatedApi';
import { BodyText } from '@/components/BodyText';
import { Ellipsis } from '@/components/Ellipsis';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import { useTenants } from '@/services/tenants/useTenants';
import { styled } from '@mui/material/styles';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import { PartFinderStatusCell } from './PartFinderStatusCell';
import { PartFinderThumbnailCell } from './PartFinderThumbnailCell';
import { TopRecommendationCell } from './TopRecommendationCell';

const StyledLink = styled(Link)(({ theme }) => ({
  display: 'block',
  minWidth: 0,
  textDecoration: 'none',
  color: theme.palette.text.primary,
  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const RenderPartNumber = (parameters: GridRenderCellParams<PartFinderReport>) => {
  const { getPath } = useTenants();
  const reportPath = getPath(`part-finder-reports/${parameters.row.id}`);
  return (
    <StyledLink to={reportPath}>
      <Ellipsis text={parameters.row.partNumber} />
    </StyledLink>
  );
};

export const RenderDescription = (parameters: GridRenderCellParams<PartFinderReport>) => {
  const { description } = parameters.row;
  return description ? <BodyText>{description}</BodyText> : <BodyText sx={{ color: 'text.secondary' }}>—</BodyText>;
};

export const RenderCreator = (parameters: GridRenderCellParams<PartFinderReport>) => {
  const { selfAwareEmail } = useGetCurrentUser();
  return selfAwareEmail(parameters.row.creator?.email || '');
};

export const RenderCreatedAt = (parameters: GridRenderCellParams<PartFinderReport>) => {
  return parameters.row.createdAt ? format(new Date(parameters.row.createdAt), 'MMM d, yyyy') : '';
};

export const RenderStatus = (parameters: GridRenderCellParams<PartFinderReport>) => {
  return <PartFinderStatusCell row={parameters.row} />;
};

export const RenderTopRecommendation = (parameters: GridRenderCellParams<PartFinderReport>) => {
  return <TopRecommendationCell report={parameters.row} />;
};

export const RenderReportThumbnail = (parameters: GridRenderCellParams<PartFinderReport>) => {
  return <PartFinderThumbnailCell report={parameters.row} />;
};
